import { render, staticRenderFns } from "./SectionActionsCreate.vue?vue&type=template&id=7e96cfaa&lang=pug&"
import script from "./SectionActionsCreate.vue?vue&type=script&lang=js&"
export * from "./SectionActionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SectionActionsCreate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports